import React from 'react';
import {
  BooleanInput,
  FormWithRedirect,
  required,
  TextInput,
  useGetOne,
  useNotify,
  useRefresh,
  useUpdate,
} from 'react-admin';
import Grid from '@material-ui/core/Grid';
import DialogContent from '@material-ui/core/DialogContent';
import ModalView from './ModalView';
import CustomActions from './CustomActions';

const HomeAddressEdit = (props) => {
  const { openEdit, setOpenEdit, id } = props;
  const { data: address } = useGetOne('customer-address', id);
  const [update, { loading }] = useUpdate('customer-address');
  const notify = useNotify();
  const refresh = useRefresh();
  const handleSubmit = async (values) => {
    update(
      { payload: { id, data: values, previousData: address } },
      {
        onSuccess: () => {
          setOpenEdit(false);
          notify('Address updated successfully');
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, 'error');
        },
      },
    );
  };
  return (
    <ModalView openEdit={openEdit} setOpenEdit={setOpenEdit}>
      <FormWithRedirect
        resource="customer-address"
        record={address}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <DialogContent>
              <TextInput
                source="address_line_1"
                validate={[required()]}
                fullWidth
              />
              <TextInput source="address_line_2" fullWidth />
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <TextInput source="city" validate={[required()]} />
                </Grid>
                <Grid item xs={4}>
                  <TextInput source="state" validate={[required()]} />
                </Grid>
                <Grid item xs={4}>
                  <TextInput source="postal_code" validate={[required()]} />
                </Grid>
              </Grid>
              <BooleanInput source="is_primary" />
            </DialogContent>
            <CustomActions
              {...formProps}
              setOpenEdit={setOpenEdit}
              loading={loading}
            />
          </>
        )}
      />
    </ModalView>
  );
};

export default HomeAddressEdit;
